import { inject, Injectable } from '@angular/core';
import { IConfigData } from '@df/catalog/config//config.interfaces';
import { ConfigResource } from '@df/catalog/config/config.resource';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { NICmsApi } from '@icms/core/data/icms-api.interfaces';
import { getBlockUrl } from '../block/get-block-url';
import { ICmsConfig } from './icms-config';
import { TLoadParams } from '@df/catalog/model';
interface IRetrieveRequest {
    bareUrl: string;
    variant?: string;
}

@Injectable({
    providedIn: 'root'
})
export class ICmsConfigResource extends ConfigResource<ICmsConfig> {
    static override instance = ICmsConfig;
    private iCmsContentService = inject(ICmsContentService);

    async save(model: ICmsConfig): Promise<NICmsApi.ISaveResponse<number>> {
        const data: NICmsApi.ISaveRequest<IConfigData, number> = {
            id: model.id < 0 ? undefined : model.id,
            type: model.type,
            data: model.rawData!
        };
        return this.requestService.send<NICmsApi.ISaveResponse<number>>(undefined, {
            path: 'cms/save',
            data,
            api: 'node',
            token: true
        });
    }

    async retrieve<TContent = any>(
        request: IRetrieveRequest,
        params: Partial<TLoadParams> | undefined // keep it mandatory, its importatnt to pass params when possible mainly for loader
    ): Promise<ICmsConfig<IConfigData<TContent>> | undefined> {
        const url = getBlockUrl(request.bareUrl, request.variant);

        try {
            return await this.loadModelByUrl(url, params);
        } catch (err) {
            return this.init(request.bareUrl, request.variant);
        }
    }

    init<TContent = any>(bareUrl: string, variant?: string): ICmsConfig {
        const url = getBlockUrl(bareUrl, variant);
        const model = this.getModelByUrl(url) || this.getCreate(Math.min(0, ...this.getAll().map(i => i.id)) - 1);
        model.setData({
            id: model.id,
            url,
            type: ICmsConfig.type,
            verbosity: 1,
            content: this.iCmsContentService.initFieldset<TContent, undefined>(
                this.iCmsContentService.getConfig(bareUrl)?.fields || [],
                undefined,
                {},
                this.iCmsContentService.getConfig(bareUrl)?.initialData
            )
        });
        return model;
    }
}
